export default [
  {
    categoryName: 'Forms',
    items: [
      {
        itemName: 'Form Elements',
        itemLink: '/admin/forms/form-elements',
      },
      {
        itemName: 'Form Wizards',
        itemLink: '/admin/forms/form-wizards',
      },
      {
        itemName: 'Medium Editor',
        itemLink: '/admin/forms/medium-editor',
      },
    ],
  },
  {
    categoryName: 'Maps',
    items: [
      {
        itemName: 'Google Maps',
        itemLink: '/admin/maps/google-maps',
      },
      {
        itemName: 'Yandex Maps',
        itemLink: '/admin/maps/yandex-maps',
      },
      {
        itemName: 'Leaflet Maps',
        itemLink: '/admin/maps/leaflet-maps',
      },
      {
        itemName: 'Bubble Maps',
        itemLink: '/admin/maps/bubble-maps',
      },
      {
        itemName: 'Line Maps',
        itemLink: '/admin/maps/line-maps',
      },
    ],
  },
  {
    categoryName: 'Dashboard',
    items: [
      {
        itemName: 'Dashboard',
        itemLink: '/admin/dashboard',
      },
    ],
  },
  {
    categoryName: 'UI Elements',
    items: [
      {
        itemName: 'Typography',
        itemLink: '/admin/ui/typography',
      },
      {
        itemName: 'Buttons',
        itemLink: '/admin/ui/buttons',
      },
      {
        itemName: 'Color Pickers',
        itemLink: '/admin/ui/color-pickers',
      },
      {
        itemName: 'Notifications',
        itemLink: '/admin/ui/notifications',
      },
      {
        itemName: 'Icons',
        itemLink: '/admin/ui/icons',
      },
      {
        itemName: 'Spinners',
        itemLink: '/admin/ui/spinners',
      },
      {
        itemName: 'Grid',
        itemLink: '/admin/ui/grid',
      },
      {
        itemName: 'Modals',
        itemLink: '/admin/ui/modals',
      },
      {
        itemName: 'File Upload',
        itemLink: '/admin/ui/file-upload',
      },
      {
        itemName: 'Tree View',
        itemLink: '/admin/ui/tree-view',
      },
    ],
  },
  {
    categoryName: 'Auth',
    items: [
      {
        itemName: 'Login',
        itemLink: '/auth/login',
      },
      {
        itemName: 'Sign up',
        itemLink: '/auth/signup',
      },
    ],
  },
  {
    categoryName: 'Statistics',
    items: [
      {
        itemName: 'Charts',
        itemLink: '/admin/statistics/charts',
      },
      {
        itemName: 'Progress bars',
        itemLink: '/admin/statistics/progress-bars',
      },
    ],
  },
]
